import { Link } from "@tanstack/react-router";
import {
  OUT_OF_ITERATIONS_BODY,
  OUT_OF_ITERATIONS_TITLE,
  UPGRADE_CTA,
} from "../lib/iteration-copy";

/** Title, explanation and upgrade CTA, shared by the overlay and the modal. */
export function OutOfIterationsMessage({ titleId }: { titleId: string }) {
  return (
    <>
      <h2
        id={titleId}
        className="text-center text-2xl font-semibold text-(--text-primary)"
      >
        {OUT_OF_ITERATIONS_TITLE}
      </h2>
      <p className="mt-3 max-w-2xl text-center text-(--text-secondary)">
        {OUT_OF_ITERATIONS_BODY}
      </p>
      <Link
        to="/pricing"
        className="mt-6 flex shrink-0 items-center justify-center rounded-[36px] bg-[#3C7CA5] px-6 py-2 text-header-label text-(--text-primary)! no-underline transition-colors hover:bg-[#4a8db8]"
      >
        {UPGRADE_CTA}
      </Link>
    </>
  );
}

/**
 * Covers the lower band of a workspace once the month's allowance is spent,
 * dimming the controls above it rather than navigating away — the user keeps
 * their bearings, and the upgrade path is right where they were working.
 *
 * Renders inside the workspace container on / and /refine, both of which
 * position it; the parent must therefore be `relative`. Deliberately not a
 * modal: it is not dismissible, and the page behind it is a backdrop rather
 * than something to return to.
 */
export function OutOfIterationsOverlay() {
  return (
    <div className="absolute inset-0 z-30 flex flex-col justify-end">
      {/* Dims the workspace above the panel and swallows clicks on it. */}
      <div aria-hidden="true" className="flex-1 bg-[var(--bg-modal)]/70" />
      <section
        aria-labelledby="out-of-iterations-overlay-title"
        className="flex flex-col items-center bg-[var(--bg-modal)] px-6 py-14"
      >
        <OutOfIterationsMessage titleId="out-of-iterations-overlay-title" />
      </section>
    </div>
  );
}
